//Master Table
const masterTableFields = [
    {title: "Admin Id",
        is_searchable: true,
        class_name: 'w-110p',
        field: {
            type: "number",
            name: "id"
        },
        fetch_key: "id"
    },
    {title: "Name",
        is_searchable: true,
        field: {
            type: "text",
            name: "name"
        },
        fetch_key: "name"
    },

    {title: "Role",
        is_searchable: true,
        class_name: 'w-125p',
        field: {
            type: "select",
            name: "role_id"
        },
        option_label: "role",
        option_val: "id",
        fetch_key: "user_role"
    },
    {title: "School",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "school_id"
        },
        accessRoleIds: [2, 7],
        option_label: "school_name",
        option_val: "id",
        fetch_key: "school_name"
    },
    {title: "Branch",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "branch_id"
        },
        accessRoleIds: [2, 7],
        option_label: "branch_name",
        option_val: "id",
        fetch_key: "branch_name"
    },
    {title: "Class",
        is_searchable: true,
        field: {
            type: "multi-select",
            name: "class_id"
        },
        option_label: "class_name",
        option_val: "id",
        fetch_key: "admin_class_details",
        data_type: {
            type: "array",
            key: "class_name"
        }
    },
    {title: "Email",
        is_searchable: true,
        field: {
            type: "text",
            name: "email"
        },
        fetch_key: "user_email.email"
    },
    {title: "Status",
        is_searchable: true,
        class_name: 'w-110p',
        field: {
            type: "select",
            name: "active_status_id"
        },
        option_label: "status",
        option_val: "id",
        fetch_key: "active_status_id"
    }
];
//New Entry Form Data
const fieldNewStake = [
    {colMd: "6", label: "First Name", required: true, type: "text", name: "first_name"},
    {colMd: "6", label: "Last Name", required: false, type: "text", name: "last_name"},
    {colMd: "6", label: "Role", required: true, type: "select", name: "role_id", placeholderData: ["Select Role"]},
    {colMd: "6", label: "Email", required: true, type: "email", name: "email"},
    {colMd: "6", label: "Password", required: true, type: "text", name: "password", tagline: "Minimum 8 Characters, Maximum 15 Characters"}
];
const fieldNewPrincipal = [
    ...fieldNewStake,
    {colMd: "6", label: "School/College/Organisation", required: true, type: "select", name: "school_id", placeholderData: ["Select School/College/Organisation"], tagline: "Allocate to Admin"},
    {colMd: "6", label: "Branch", required: true, type: "select", name: "branch_id", placeholderData: ["Select Branch"], tagline: "Allocate to Admin"},
];
const fieldNewTeacher = [
    ...fieldNewPrincipal,
    {colMd: "6", label: "Grade/Class/Course", required: true, type: "multi-select", name: "class_id", placeholderData: ["Select Grade/Class/Course"], tagline: "Allocate to Admin"},
];
const fieldValuesStake = {
//   first_name: 'Admin',
//   last_name: '',
//   role_id: {id: 4, role: 'Counsellor'},
//   email: 'admin@admin.com',
// school_id : {id: 1, school_name: "Grade 1"},
//   password: '12345678'
    first_name: '',
    last_name: '',
    role_id: '',
    email: '',
    password: '',
    //Principal-teacher-Couns.
    school_id : '',
    branch_id: '',
    //Teacher
    class_id: ''
};
//Validation: New
const fieldValidationStake = {
    first_name: 'required|max:50',
    last_name: 'optional|max:50',
    role_id: 'required||Role',
    email: 'required|email|max:150',
    // mobile: 'required|digit:|min:6|max:15||WhatsApp Number',
    password: 'required|min:8|max:15'
};
const fieldValidationPrincipal = {
    ...fieldValidationStake,
    school_id: 'required||School/College/Organisation',
    branch_id: 'required||Branch'
};
const fieldValidationTeacher = {
    ...fieldValidationPrincipal,
    class_id: 'required||Grade/Class/Course'
};
//Validation: Edit
const fieldValidEditStake = {
    first_name: 'required|max:50',
    last_name: 'optional|max:50',
    // role_id: 'required||Role',
    // email: 'required|email|max:150',
    // mobile: 'required|digit:|min:6|max:15||WhatsApp Number',
    password: 'optional|min:8|max:15',
    // school_id: 'required||School/College/Organisation'
};
const fieldValidEditTeacher = {
    ...fieldValidEditStake,
    class_id: 'required||Grade/Class/Course'
};
//View Form Data
const fieldStakeView = [
  {label: "Role", type: "string", value_key: "user_role"},
  {label: "First Name", type: "string", value_key: "first_name"},
  {label: "Last Name", type: "string", value_key: "last_name"},
  {label: "Email", type: "object", value_key: "user_email.email"},
  {label: "School", type: "string", value_key: "school_name"},
  {label: "Branch", type: "string", value_key: "branch_name"},
//   {label: "Class", type: "string", value_key: "class_name"}
];
const fieldStakeViewTeach = [
    ...fieldStakeView,
    // {label: "Class", type: "string", value_key: "class_name"}
    {label: "Class", type: "array", value_key: "admin_class_details", array_key: "class_name"},
  ];
//Edit
const fieldEditStake = [
    {colMd: "6", label: "First Name", required: true, type: "text", name: "first_name"},
    {colMd: "6", label: "Last Name", required: false, type: "text", name: "last_name"},
    // {colMd: "6", label: "Role", required: true, type: "select", name: "role_id", placeholderData: ["Select Role"]},
    // {colMd: "6", label: "Email", required: true, type: "email", name: "email"},
    {colMd: "6", label: "Password", required: false, type: "text", name: "password", tagline: "Minimum 8 Characters, Maximum 15 Characters"},
    // {colMd: "6", label: "School/College/Organisation", required: true, type: "select", name: "school_id", placeholderData: ["Select School/College/Organisation"], tagline: "Allocate to Admin"}
    ];
const fieldEditTeacher = [...fieldEditStake,
    {colMd: "6", label: "Grade/Class/Course", required: true, type: "multi-select", name: "class_id", placeholderData: ["Select Grade/Class/Course"], tagline: "Allocate to Admin"},
    ];
const data = {
    //Common
    fieldNewStake,
    fieldValuesStake,
    fieldNewTeacher,
    fieldValidationStake,
    fieldValidationTeacher,
    fieldStakeView,
    fieldStakeViewTeach,
    fieldEditStake,
    fieldEditTeacher,
    fieldValidEditTeacher,
    fieldValidEditStake,
    //Principal & Counsellor
    fieldNewPrincipal,
    fieldValidationPrincipal,
    masterTableFields
};

export default data;